import { CommonModule } from '@angular/common';
import { Injectable, NgModule, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard
} from '@bepatient/core';
import {
  MyAccountActionLoadForms,
  MyAccountStoreModule,
  selectorMyAccountForms
} from '@bepatient/my-account-store';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MyAccountItemComponent } from './components/my-account-item/my-account-item.component';
import { MyAccountIconComponent } from './components/my-account-icon/my-account-icon.component';
import { MyAccountToolbarComponent } from './components/my-account-toolbar/my-account-toolbar.component';
import { Store } from '@ngrx/store';

@Injectable()
export class MyAccountGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(store, selectorMyAccountForms, new MyAccountActionLoadForms());
  }
}

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.MY_ACCOUNT,
  i18nLabel: 'MODULES.MY_ACCOUNT',
  icon: 'person',
  leftMenuAvailableForPages: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  routes: [
    {
      path: 'my-account',
      canActivate: [MyAccountGuard],
      loadChildren: () =>
        import('./pages/my-account/my-account.module').then(
          m => m.MyAccountPageModule
        )
    },
    {
      path: 'my-account-tos',
      loadChildren: () =>
        import('./pages/my-account-tos/my-account-tos.module').then(
          m => m.MyAccountTosPageModule
        )
    },
    {
      path: 'my-account-tos-details',
      loadChildren: () =>
        import(
          './pages/my-account-tos-details/my-account-tos-details.module'
        ).then(m => m.MyAccountTosDetailsPageModule)
    },
    {
      path: 'my-account-password',
      loadChildren: () =>
        import('./pages/password/my-account-password.module').then(
          m => m.MyAccountPasswordPageModule
        )
    },
    {
      path: 'my-change-email',
      loadChildren: () =>
        import('./pages/my-change-email/my-change-email.module').then(
          m => m.MyChangeEmailModule
        )
    },
    {
      path: 'my-account-privacy-policy',
      loadChildren: () =>
        import(
          './pages/my-account-privacy-policy/my-account-privacy-policy.module'
        ).then(m => m.MyAccountPrivacyPolicyPageModule)
    },
    {
      path: 'my-account-document',
      loadChildren: () =>
        import('./pages/my-account-document/my-account-document.module').then(
          m => m.MyAccountDocumentModule
        )
    },
    {
      path: 'my-account-user-preference',
      loadChildren: () =>
        import(
          './pages/my-account-user-preference/my-account-user-preference.module'
        ).then(m => m.MyAccountUserPreferencePageModule)
    },
    {
      path: 'my-account-help',
      loadChildren: () =>
        import('./pages/my-account-help/my-account-help.module').then(
          m => m.MyAccountHelpModule
        )
    },
    {
      path: 'my-account/:pageType',
      loadChildren: () =>
        import('./pages/my-account/my-account.module').then(
          m => m.MyAccountPageModule
        )
    }
  ]
};

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    MyAccountStoreModule,
    TranslateModule,
    RouterModule.forChild(pageModule.routes)
  ],
  providers: [
    MyAccountGuard,
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './my-account/i18n/', multi: true }
  ],
  exports: [
    MyAccountItemComponent,
    MyAccountIconComponent,
    MyAccountToolbarComponent
  ],
  declarations: [
    MyAccountItemComponent,
    MyAccountIconComponent,
    MyAccountToolbarComponent
  ]
})
export class MyAccountModule {}
